module.exports = __webpack_public_path__ + "static/media/Logo__StateFarm.720dc807.svg";